// extracted by mini-css-extract-plugin
export default {"form":"styles_form__NdY87","input":"styles_input__Vo8po"};